export const sendTypingStatus = (socketRef, recipientMobile, isTyping) => {
  const socket = socketRef.current;
  if (!socket || socket.readyState !== WebSocket.OPEN) return;
  const payload = { to: recipientMobile, isTyping };
  socket.send(JSON.stringify({ action: "typing", data: JSON.stringify(payload) }));
};
